import React, { useMemo, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import { useTheme } from "@material-ui/core/styles";
import AccountCircle from "@material-ui/icons/AccountCircle";

const buildAbsoluteUrl = (baseUrl, relativePath) => {
  if (!baseUrl) return relativePath;

  const normalizedBase = baseUrl.replace(/\/+$/, "");
  const normalizedPath = relativePath.startsWith("/")
    ? relativePath
    : `/${relativePath}`;

  return `${normalizedBase}${normalizedPath}`;
};

const normalizeSrc = (value) => {
  if (value === null || value === undefined) return "";

  if (typeof value !== "string") return "";

  const trimmed = value.trim();
  if (!trimmed) return "";

  const lower = trimmed.toLowerCase();
  if (lower === "null" || lower === "undefined" || lower === "-" || lower === "none") {
    return "";
  }

  if (
    lower.startsWith("http://") ||
    lower.startsWith("https://") ||
    lower.startsWith("data:") ||
    lower.startsWith("blob:")
  ) {
    return trimmed;
  }

  if (trimmed.startsWith("//")) {
    return `https:${trimmed}`;
  }

  return buildAbsoluteUrl(process.env.REACT_APP_BACKEND_URL, trimmed);
};


const ContactAvatar = ({ src, alt, imgProps, style, onImageError, ...rest }) => {
  const theme = useTheme();

  const normalizedSrc = useMemo(() => normalizeSrc(src), [src]);
  const [failedSrc, setFailedSrc] = useState(null);

  const isDarkTheme = theme.palette.type === "dark" || theme.palette.mode === "dark";
  const backgroundColor = isDarkTheme ? "#646464" : "#a4a4a4";
  const iconColor = isDarkTheme ? "#242424" : "#f3f3f3";

  const combinedStyle = {
    backgroundColor,
    ...style
  };

  return (
    <Avatar
      src={onImageError ? undefined : (normalizedSrc || undefined)}
      alt={alt}
      imgProps={{
        referrerPolicy: "no-referrer",
        ...imgProps
      }}
      style={combinedStyle}
      {...rest}
    >
      {onImageError && normalizedSrc && failedSrc !== normalizedSrc ? (
        <img
          {...imgProps}
          src={normalizedSrc}
          alt={alt}
          referrerPolicy="no-referrer"
          style={{ width: "100%", height: "100%", objectFit: "cover", ...imgProps?.style }}
          onError={event => {
            setFailedSrc(normalizedSrc);
            if (imgProps?.onError) imgProps.onError(event);
            onImageError(event);
          }}
        />
      ) : <AccountCircle style={{ width: '125%', height: '125%', color: iconColor }} />}
    </Avatar>
  );
};

ContactAvatar.defaultProps = {
  alt: "",
  imgProps: undefined,
  style: undefined,
};

export default ContactAvatar;
